import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Eyebrow — uppercase mono meta line used above headings and inside card heads.
 * Example: <Eyebrow>DAY <b>17</b> · MONTH ONE · ACQUISITION ROUTE</Eyebrow>
 * <b> children render in fd-text-muted (slightly brighter than the surrounding subtle text).
 */
export interface EyebrowProps extends React.HTMLAttributes<HTMLSpanElement> {
  as?: keyof React.JSX.IntrinsicElements;
}

export const Eyebrow = React.forwardRef<HTMLSpanElement, EyebrowProps>(
  ({ className, as: Tag = 'span', ...props }, ref) => {
    const Comp = Tag as 'span';
    return (
      <Comp
        ref={ref as React.Ref<HTMLSpanElement>}
        className={cn(
          'inline-block font-geist-mono text-[10.5px] font-medium leading-none',
          'tracking-[0.06em] uppercase text-fd-text-subtle',
          '[&>b]:text-fd-text-muted [&>b]:font-medium',
          className,
        )}
        {...props}
      />
    );
  },
);
Eyebrow.displayName = 'Eyebrow';
